import React, { Fragment, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom/dist";
import Table from "../../../core/pagination/datatable";
import { ErrorToaster } from "../../components/toaster/Toaster";
import { cleanObject, Debounce, getDate } from "../../../utils";
import ReportServices from "../../../services/Report";
import { all_routes } from "../../../Router/all_routes";
import { PlusCircle } from "feather-icons-react/build/IconComponents";

const Customers = () => {

  const routes = all_routes;

  const [searchParams, setSearchParams] = useSearchParams();

  // *For Loader
  const [loader, setLoader] = useState(false);

  // *For Customers
  const [customers, setCustomers] = useState([]);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const pageLimit = parseInt(searchParams.get("limit") || "10", 10);
  const searchText = searchParams.get("search") || "";

  // *For Get Customer Orders
  const getCustomerOrders = async (page = currentPage, limit = pageLimit) => {
    setLoader(true)
    try {
      const params = { ...Object.fromEntries(searchParams.entries()), page, limit }
      const { data, pagination } = await ReportServices.getCustomerOrders(params)
      setCustomers(data)
      setTotalCount(pagination?.total)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  const columns = [
    {
      title: "Customer Code",
      dataIndex: "customerCode",
    },
    {
      title: "Customer Name",
      dataIndex: "first_name",
      render: (text, record) => (
        <span>
          {record.first_name} {record.last_name}
        </span>
      )
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Order Count",
      dataIndex: "orderCount",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      render: (amount) => (
        <span>
          ${amount ? parseFloat(amount).toFixed(2) : 0}
        </span>
      )
    },
    {
      title: "First Order Date",
      dataIndex: "firstOrderDate",
      render: (date) => (
        <span>
          {getDate(date)}
        </span>
      )
    },
    {
      title: "Last Order Date",
      dataIndex: "lastOrderDate",
      render: (date) => (
        <span>
          {getDate(date)}
        </span>
      )
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              to={routes?.createSale}
              state={{ phone: record?.phone }}
              className="btn btn-sm btn-primary btn-wave waves-effect waves-light me-2"
            >
              Create New Sale
            </Link>
            <Link
              className="me-2 p-2"
              to={`/customer-orders/${record.customerId}`}
            >
              <i data-feather="eye" className="feather-eye"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  // *For Handle Pagination and Filters
  const handlePaginationFilter = (data) => {
    try {
      const updatedParams = {
        ...Object.fromEntries(searchParams.entries()),
        page: 1,
        ...cleanObject(data)
      };
      Debounce(() => setSearchParams(updatedParams));
    } catch (error) {
      console.log(' handlePaginationFilter => error:', error)
    }
  }

  useEffect(() => {
    getCustomerOrders()
  }, [searchParams]);

  return (
    <Fragment>

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Customer List</h4>
              </div>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      defaultValue={searchText}
                      className="form-control form-control-sm formsearch"
                      onChange={(e) => handlePaginationFilter({ search: e.target.value })}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={customers}
                  totalCount={totalCount}
                  pageSize={pageLimit}
                  currentPage={currentPage}
                  onChange={(page, pageSize) => handlePaginationFilter({ page: page, limit: pageSize })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Customers;
